import { useEffect, useState, useCallback } from 'react';
import { products } from '@/mocks/multifierros';

const productImages: Record<string, string> = {
  'prod-marcos-viga': 'https://public.readdy.ai/ai/img_res/edited_25968148d7d02db03cfa6d20e663ee7d_27688dd0.jpg',
  'prod-marcos-reticulados': 'https://public.readdy.ai/ai/img_res/edited_8a84e6fcf4437af321f50e7790afcddf_08afb339.jpg',
  'prod-splitset': 'https://public.readdy.ai/ai/img_res/edited_9b4e5f370d5bfbe6cb815ae3e6eb6bed_7322faa2.jpg',
  'prod-tuercas-placas': 'https://public.readdy.ai/ai/img_res/edited_8117c723e112b820573631182fcf5318_ea0fe19e.jpg',
  'prod-anillos-blindaje': 'https://public.readdy.ai/ai/img_res/edited_b652f720c778806750e846cad6843413_9281590c.jpg',
  'prod-estructuras-metalicas': 'https://readdy.ai/api/search-image?query=Underground%20mining%20tunnel%20entrance%20with%20heavy%20duty%20galvanized%20steel%20staircase%20structure%2C%20dark%20gray%20metal%20stairs%20with%20dual%20handrails%20and%20non-slip%20grating%20steps%20installed%20inside%20a%20rocky%20mine%20tunnel%20entrance%20with%20rock%20walls%20and%20industrial%20lighting%2C%20rugged%20mining%20environment%20with%20conveyor%20belt%20in%20background%2C%20professional%20industrial%20photography%20sharp%20detail%20photorealistic%20dramatic%20contrast&width=900&height=600&seq=modal-estructuras-mineras&orientation=landscape&nocache=true',
};

const productDetailTitles: Record<string, string> = {
  'prod1': 'Fabricación y Reparación Marcos Viga',
  'prod2': 'Fabricación Marcos Reticulados',
  'prod3': 'FABRICACION DE SPLIT SET - PLANCHUELAS - BARRAS HELICOIDALES',
  'prod4': 'Tuercas, Placas y Acoples',
  'prod6': 'Anillos de Blindaje',
  'prod7': 'Fabricación Estructuras Metálicas',
};

const secondaryProductImages: Record<string, string[]> = {
  'prod-marcos-reticulados': [
    'https://public.readdy.ai/ai/img_res/edited_c8f4d927276b966c2104cf0e091846b6_08afb339.jpg',
    'https://public.readdy.ai/ai/img_res/edited_866a52c0b0ab640534eddf71c96c06c9_08afb339.jpg',
    'https://public.readdy.ai/ai/img_res/edited_24f882acd1499bb4b8efe3d78b9f5ed2_08afb339.jpg',
  ],
  'prod-marcos-viga': [
    'https://public.readdy.ai/ai/img_res/edited_9b51e389db39bb8214cbb1ccd4a3e6bb_1ac004cf.jpg',
    'https://public.readdy.ai/ai/img_res/edited_dc5cdd7dc93de3f6c057d3e2276ee99a_97fb9568.jpg',
    'https://public.readdy.ai/ai/img_res/edited_282e62508dc57f45e68957b57544c78b_1a49dbac.jpg',
    'https://public.readdy.ai/ai/img_res/edited_51a77a87a8e68b60e3ef092b78c4afc2_8c86a09b.jpg',
    'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/251dfa49580c04f282e109656c02ed4b.png',
    'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/6bc60bb16a9bfb8529178848aac2a119.png',
  ],
  'prod-anillos-blindaje': [
    'https://public.readdy.ai/ai/img_res/edited_d9023e8d7a12b2d4c61cf13a6a52d654_0e15a59d.jpg',
    'https://public.readdy.ai/ai/img_res/edited_f3da62ea39c3dc9f50c29226de7702a4_cd142bc7.jpg',
    'https://public.readdy.ai/ai/img_res/edited_816d13b296b9cbf718ccf1e808a31df1_d08932ef.jpg',
  ],
  'prod-corte-combinado': [
    'https://public.readdy.ai/ai/img_res/edited_f8841234cc9ac8f7185447c75faf7068_f614dd91.jpg',
  ],
  'prod-splitset': [
    'https://public.readdy.ai/ai/img_res/edited_6b57732b03811744d0c04714175be266_fae474cf.jpg',
  ],
  'prod-tuercas-placas': [
    'https://public.readdy.ai/ai/img_res/edited_efb6feb802f467183161b83ab1d57eab_c796f265.jpg',
  ],
  'prod-estructuras-metalicas': [
    'https://readdy.ai/api/search-image?query=Large%20steel%20frame%20industrial%20mining%20warehouse%20shed%20under%20construction%20in%20desert%20mining%20site%2C%20red%20oxide%20primed%20steel%20columns%20and%20roof%20trusses%20assembled%2C%20bright%20sunny%20day%20with%20mountains%20in%20background%2C%20heavy%20equipment%20and%20crane%20nearby%2C%20rugged%20mining%20camp%20environment%2C%20professional%20industrial%20photography%20sharp%20detail%20photorealistic%20high%20contrast&width=900&height=600&seq=modal-estructuras-galpon&orientation=landscape',
  ],
};

interface ProductDetailModalProps {
  productId: string | null;
  onClose: () => void;
}

export default function ProductDetailModal({ productId, onClose }: ProductDetailModalProps) {
  const product = products.find((p) => p.id === productId);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const mainImage = product ? productImages[product.imageSeq] : undefined;
  const extras = product ? secondaryProductImages[product.imageSeq] || [] : [];
  const allImages = mainImage ? [mainImage, ...extras] : [];
  const hasMultipleImages = allImages.length > 1;

  // Reset state & lock scroll when modal opens/closes
  useEffect(() => {
    if (!productId) return;
    setCurrentImageIndex(0);
    setExpanded(false);
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [productId]);

  // Escape key handler — needs current expanded value
  useEffect(() => {
    if (!productId) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (expanded) {
          setExpanded(false);
        } else {
          onClose();
        }
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [productId, expanded, onClose]);

  useEffect(() => {
    if (!expanded) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') goNext();
      else if (e.key === 'ArrowLeft') goPrev();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [expanded, currentImageIndex]);

  const goNext = useCallback(() => {
    setCurrentImageIndex((prev) => (prev + 1) % allImages.length);
  }, [allImages.length]);

  const goPrev = useCallback(() => {
    setCurrentImageIndex((prev) => (prev - 1 + allImages.length) % allImages.length);
  }, [allImages.length]);

  if (!product) return null;

  return (
    <>
      {/* Main Modal */}
      <div
        className="fixed inset-0 z-[60] flex items-center justify-center p-4 md:p-8"
        onClick={onClose}
      >
        <div className="absolute inset-0 bg-black/70"></div>

        <div
          className="relative bg-background-50 rounded-sm max-w-3xl w-full max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-background-300/80 hover:bg-background-200 text-foreground-50 rounded-full transition-colors cursor-pointer"
            aria-label="Cerrar"
          >
            <i className="ri-close-line text-lg"></i>
          </button>

          {/* Gallery area */}
          <div className="relative w-full h-56 md:h-80 overflow-hidden">
            <img
              src={allImages[currentImageIndex]}
              alt={productDetailTitles[product.id] || product.title}
              className="w-full h-full object-cover object-center"
            />

            {/* Clickable overlay — covers the entire image */}
            <div
              className="absolute inset-0 cursor-pointer group/expand"
              onClick={() => setExpanded(true)}
              role="button"
              tabIndex={0}
              aria-label="Ampliar imagen"
            >
              <div className="absolute inset-0 bg-black/0 group-hover/expand:bg-black/20 transition-colors duration-300"></div>
              <div className="absolute bottom-3 right-3 bg-black/60 text-white text-xs px-3 py-1.5 rounded-sm flex items-center gap-1.5 opacity-80 group-hover/expand:opacity-100 transition-opacity">
                <i className="ri-zoom-in-line"></i>
                <span>Click para ampliar</span>
              </div>
            </div>

            {hasMultipleImages && (
              <>
                <button
                  onClick={(e) => { e.stopPropagation(); goPrev(); }}
                  className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors cursor-pointer z-10"
                  aria-label="Imagen anterior"
                >
                  <i className="ri-arrow-left-s-line text-lg"></i>
                </button>
                <button
                  onClick={(e) => { e.stopPropagation(); goNext(); }}
                  className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors cursor-pointer z-10"
                  aria-label="Imagen siguiente"
                >
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </button>
              </>
            )}

            {hasMultipleImages && (
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
                {allImages.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(idx); }}
                    className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${idx === currentImageIndex ? 'bg-white' : 'bg-white/50 hover:bg-white/80'}`}
                    aria-label={`Imagen ${idx + 1}`}
                  />
                ))}
              </div>
            )}
          </div>

          <div className="p-6 md:p-10">
            <span className="inline-block bg-primary-900 text-primary-100 text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-sm mb-4">
              {product.badge}
            </span>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 tracking-wide mb-4">
              {productDetailTitles[product.id] || product.title}
            </h2>

            <p className="text-foreground-300 text-sm md:text-base leading-relaxed mb-6">
              {product.description}
            </p>

            {'specs' in product && product.specs && product.specs.length > 0 && (
              <div className="border-t border-background-300/40 pt-6 mt-2">
                <h3 className="font-heading text-lg text-foreground-200 tracking-wide mb-4">
                  Especificaciones Técnicas
                </h3>
                <div className="grid grid-cols-2 gap-3">
                  {product.specs.map((spec: { label: string; value: string }) => (
                    <div
                      key={spec.label}
                      className="bg-background-100 rounded-sm px-4 py-3 border border-background-300/40"
                    >
                      <p className="text-foreground-300 text-xs uppercase tracking-wider mb-0.5">{spec.label}</p>
                      <p className="text-foreground-100 text-sm font-semibold">{spec.value}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="mt-8 pt-6 border-t border-background-300/40">
              <a
                href="#contacto"
                onClick={onClose}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm uppercase tracking-wider px-8 py-3 rounded-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                Solicitar Cotización
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox — completely outside the modal card */}
      {expanded && (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setExpanded(false)}
        >
          <div className="relative w-full max-w-[1200px] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>

            <button
              onClick={() => setExpanded(false)}
              className="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center rounded-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            {hasMultipleImages && (
              <div className="absolute -top-12 left-0 text-white/60 text-sm font-medium">
                {currentImageIndex + 1} / {allImages.length}
              </div>
            )}

            {hasMultipleImages && (
              <>
                <button
                  onClick={(e) => { e.stopPropagation(); goPrev(); }}
                  className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors cursor-pointer backdrop-blur-sm"
                  aria-label="Imagen anterior"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={(e) => { e.stopPropagation(); goNext(); }}
                  className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors cursor-pointer backdrop-blur-sm"
                  aria-label="Imagen siguiente"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </>
            )}

            <img
              src={allImages[currentImageIndex]}
              alt={`${productDetailTitles[product.id] || product.title} - imagen ${currentImageIndex + 1}`}
              className="w-full max-h-[85vh] object-contain rounded-sm"
            />

            {hasMultipleImages && (
              <div className="flex items-center gap-2 mt-4">
                {allImages.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(idx); }}
                    className={`h-2 rounded-full transition-all cursor-pointer ${
                      idx === currentImageIndex
                        ? 'bg-white w-6'
                        : 'bg-white/40 hover:bg-white/70 w-2'
                    }`}
                    aria-label={`Ir a imagen ${idx + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}